/* eslint-disable no-console */

import { register } from 'register-service-worker'

// Service workers only work on HTTPS or localhost (not on IP addresses)
// Check if we're on localhost or HTTPS before registering
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '[::1]'
)
const isHttps = window.location.protocol === 'https:'
const canUseServiceWorker = (isLocalhost || isHttps) && 'serviceWorker' in navigator

// Only log in development
const isDev = process.env.NODE_ENV === 'development'
const log = isDev ? console.log : () => {}
const logError = isDev ? console.error : () => {}

// Enable service worker in both development and production for localhost testing
if (process.env.NODE_ENV === 'production' || isLocalhost) {
  if (!canUseServiceWorker) {
    if (isDev) {
      logError('Service worker cannot be registered (not HTTPS or localhost)')
    }
  } else {
    register(`${process.env.BASE_URL}service-worker.js`, {
      ready() {
        log('App is being served from cache by a service worker.')
      },
      registered(registration) {
        log('Service worker has been registered.')
        
        // Store registration globally for testing
        window.serviceWorkerRegistration = registration
        
        // Check for updates periodically (every 60 seconds)
        setInterval(() => {
          registration.update()
        }, 60000)
        
        // Also check immediately
        registration.update()
      },
      cached() {
        log('Content has been cached for offline use.')
      },
      updatefound() {
        log('New content is downloading.')
      },
      updated(registration) {
        log('New content is available; please refresh.')
        // Service worker will automatically activate with skipWaiting: true
        // Page will reload automatically when new service worker takes control
      },
      offline() {
        log('No internet connection found. App is running in offline mode.')
      },
      error(error) {
        logError('Error during service worker registration:', error)
      }
    })

    // // Listen for controller change to reload when new service worker takes control
    // if ('serviceWorker' in navigator) {
    //   let refreshing = false
    //   navigator.serviceWorker.addEventListener('controllerchange', () => {
    //     log('Service worker controller changed, reloading...')
    //     if (!refreshing) {
    //       refreshing = true
    //       window.location.reload()
    //     }
    //   })
    // }
  }
}
